const PENDING_MSG = '-';
const NOT_APPLICABLE_MSG = 'N/A';
const NO_COMPLETED_APPLICATIONS_MESSAGE = 'You haven’t received any applications yet.';
const INIT_LISTING_APPLICATIONS_TAB_ERROR = 'Error initializing listing applications tab';
const INIT_LANDLORD_REVIEW_ERROR = 'The application you requested failed to load. Please try again later.';
const CANNOT_FIND_SNAPSHOT_MESSAGE = 'Cannot find application snapshot.';
const CANNOT_FIND_SNAPSHOT_ERROR = 'The application you requested does not exist.';
const INVALID_NAME_MSG = 'please enter a valid name not exceeding 32 letters';
const INVALID_EMAIL_MSG = 'please enter a valid email address';
const CUSTOMER_SUPPORT_MESSAGE = 'For additional questions or concerns, please contact customer support at ';
const FETCH_DATA_ERROR_MSG = `We're sorry, something went wrong. Please refresh the page to load your completed applications.`;
const VOUCHER_COVERS_RENT = 'Voucher covers rent';

export {
  PENDING_MSG,
  NOT_APPLICABLE_MSG,
  NO_COMPLETED_APPLICATIONS_MESSAGE,
  INIT_LISTING_APPLICATIONS_TAB_ERROR,
  INIT_LANDLORD_REVIEW_ERROR,
  CANNOT_FIND_SNAPSHOT_MESSAGE,
  CANNOT_FIND_SNAPSHOT_ERROR,
  INVALID_NAME_MSG,
  INVALID_EMAIL_MSG,
  CUSTOMER_SUPPORT_MESSAGE,
  FETCH_DATA_ERROR_MSG,
  VOUCHER_COVERS_RENT,
};
